import { useEffect, useState } from "react";
import { Crown, Shield } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

export const ModsLeaderboard = ({ refreshKey }) => {
  const { t } = useI18n();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/live/mods").then((r) => setD(r.data)).catch(() => setD(null)); }, [refreshKey]);
  if (!d) return null;
  return (
    <div className="cx-card rounded-2xl p-5 mt-6" data-testid="mods-leaderboard">
      <div className="flex items-center justify-between gap-3">
        <div className="cx-label flex items-center gap-2"><Shield className="w-3.5 h-3.5 text-[#22e3a1]" />{t("mods.title")}</div>
        <span className="font-mono text-[11px] text-slate-500" data-testid="mods-month">{d.month}</span>
      </div>
      <p className="text-xs text-slate-500 mt-1">{t("mods.desc")}</p>
      {d.rows.length === 0 ? (
        <div className="text-sm text-slate-400 mt-4" data-testid="mods-empty">{t("mods.empty")}</div>
      ) : (
        <div className="divide-y divide-white/5 mt-3">
          {d.rows.map((r) => (
            <div key={r.name} className="flex items-center gap-3 py-2.5" data-testid={`mods-row-${r.rank}`}>
              <span className={`w-7 text-center font-mono text-sm ${r.rank === 1 ? "text-[#ffc94d]" : "text-slate-500"}`}>{r.rank === 1 ? <Crown className="w-4 h-4 inline" /> : `#${r.rank}`}</span>
              <span className="flex-1 min-w-0 truncate text-white text-sm">{r.name}</span>
              <span className="text-xs text-slate-400">{t("mods.clips", { n: r.clips })}</span>
              <span className="font-mono text-sm text-[#3ad7ff] w-20 text-right">{t("mods.views", { n: r.views })}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
